export default {
  gracePeriod: 15,
  logTypes: {
    share: "Share",
    pagevisit: "PageVisit",
    login: "Login",
    logout: "Logout",
    viewItem: "ViewItem",
    audioClick: "AudioClick",
    downloadClick: "DownloadClick",
    pipelineClick: "PipelineClick",
    filter: "Filter",
    examResult: "ExamResult",
    quizResult: "QuizResult",
    flashcardFlip: "FlashcardFlip",
    flashcardsReset: "FlashcardsReset",
    feedbackSent: "FeedbackSent",
    pageVisit: "PageVisit",
    viewedItemBlacklisted: "ViewedItemBlacklisted",
    subscription: "Subscription",
    purchase: "Purchase",
    spxPurchaseClick: "SpxPurchaseClick",
  },
  commentTypes: {
    feedback: "Feedback",
  },
  contentTypes: {
    contentItem: "ContentItem",
    click: "Click",
    feedback: "Feedback",
    pageVisit: "PageVisit",
    userLogin: "UserLogin",
  },
  commentGroupKeys: {
    general: "FDGeneralFeedback",
    content: "FDContentFeedback",
    notFound: "FDContentNotFound"
  },
  commentGroupTitles: {
    general: "General Feedback",
    content: "Content Feedback",
    notFound: "Content Not Found"
  },
  commentOptionGroupKeys: {
    CommunicationFrequency: "CommunicationFrequency",
    CostPreference: "CostPreference",
    LikelyActions: "LikelyActions",
    CommunicationMode: "CommunicationMode",
    ValuableFeatures: "ValuableFeatures"
  },
  contentSubTypes: {
    audioClick: "AudioClick",
    downloadClick: "DownloadClick",
    pipelineClick: "PipelineClick",
    filterClick: "FilterClick",
    feedbackForm: "FeedbackForm",
    itemFeedback: "ItemFeedback",
    page: "Page",
    exam: "Exam",
    quiz: "Quiz",
    video: "Video",
    quickread: "Quickread",
    flashcards: "Flashcards",
  },
  get edgeLoggingContentSubtypeMap() {
    return {
      CTQuickread: this.contentSubTypes.quickread,
      CTQuiz: this.contentSubTypes.quiz,
      CTFlashcards: this.contentSubTypes.flashcards,
      CTVideo: this.contentSubTypes.video,
      CTExam: this.contentSubTypes.exam,
    };
  },
  contentKeys: {
    audio: "Audio",
    download: "Download",
    sidebar: "Sidebar",
    quickreads: "Quickreads",
    notFoundForm: "FeedbackForm",
    generalFeedbackForm: "GeneralFeedbackForm",
    topicFilter: "TopicFilter",
    typeFilter: "TypeFilter",
    specialFilter: "SpecialFilter",
  },
  contentSubKeyPartials: {
    types: "types-",
    topics: "topics-",
    special: "special-",
  },
  pageKeys: {
    exam: "exam-page",
    home: "home-page",
    aboutUs: "about-us-page",
    examPassed: "exam-passed-page",
    account: "account-page",
    landingPage: "landing-page",
    glossary: "glossary-page",
    login: "login-page",
    logout: "logout-page",
  },
  libraryName: {
    edge: "PMEdge",
    standards: "Standards",
  },
  fileKey: {
    transcripts: "Transcripts",
    mainContent: "MainContent",
    previewImage: "PreviewImage",
    additionalMedia: "AdditionalMedia",
    referenceFile: "ReferenceFile",
    videoMedia: "VideoMedia",
    audioMedia: "AudioMedia",
  },
  fileFormat: {
    brightcove: "brightcove",
    link: "link",
  },
  status: {
    pending: "Pending",
    approved: "Approved",
    denied: "Denied",
    archived: "Archived",
  },
  playlist: {
    default: "Default",
  },
};
export const CALLED = 'Called';
export const COMPLETED = 'Completed';
export const NOT_CALLED = 'NotCalled';